import { Component, computed, input } from '@angular/core';

@Component({
  selector: 'onboarding-progress-bar',
  standalone: true,
  templateUrl: './progress-bar.component.html',
  styleUrl: './progress-bar.component.scss',
})
export class ProgressBarComponent {
  public step = input<number>();
  public totalSteps = input<number>();

  public width = computed(() => (this.step() && this.totalSteps() ? `${(this.step() / this.totalSteps()) * 100 - 2.5}%` : '0%'));
}
